module.exports = "<span class=\"tag {{labelVariant}} {{labelType}}\">\n\t<slot></slot>\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/tags/tags.html
// module id = 4
// module chunks = 0